<template>
  <div>
    <div class="wrapper d-flex flex-column min-vh-100 bg-light">
      <SimpleAppHeader />
      <div class="body flex-grow-1 px-3">
        <CContainer lg>
          <router-view />
        </CContainer>
      </div>
      <AppFooter />
    </div>
  </div>
</template>
<script>
import { CContainer } from '@coreui/vue'
import AppFooter from '@/components/AppFooter.vue'
import SimpleAppHeader from '@/components/SimpleAppHeader.vue'

export default {
  name: 'DefaultLayout',
  components: {
    AppFooter,
    SimpleAppHeader,
    CContainer,
  },
}
</script>
